// Service plan section form field enum
export enum ServicePlanFormField {
  TASKS = 'service-plan/patient-tasks'
}
